// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"page_filterContainer__aLGP3","page":"page_page__oy5Yi","searchToggle":"page_searchToggle__Vmd1P"};